import { render, staticRenderFns } from "./GroupInsurancePolicyEdit.vue?vue&type=template&id=3c632f27"
import script from "./GroupInsurancePolicyEdit.vue?vue&type=script&lang=js"
export * from "./GroupInsurancePolicyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports